@if (actionSection) {
  <mat-progress-bar class="audio-progress-bar wrapper prog-bar-zoom" mode="determinate" [value]="progress" [attr.aria-valuetext]="progressDescription"></mat-progress-bar>
  <div aria-live="polite" aria-atomic="true" class="sr-only"> {{ progressDescription }} </div>
}